/**
 * Definition of the AsyncUtil instance.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2026
 */

import { getAsyncUtil } from '@amplify3/duplo-back-end'
import { baseURL } from './env'
export const asyncUtil = getAsyncUtil(baseURL)
